import React from 'react';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import {
  selectSystemMaintenanceMessage,
  selectSystemMaintenanceShowUntilTime
} from 'shared/store/modules/systemMaintenanceMessage/selectors';
import styles from './SystemMaintenanceMessage.styles';
import Section from 'shared/components/Section';

export const SystemMaintenanceMessage = ({
  wrapperElement = 'div',
  wrapperProps = {},
  wrapWithSection,
  sectionProps = {},
  ...props
}) => {
  const systemMaintenance = useSelector(selectSystemMaintenanceMessage);
  const systemMaintenanceUntilTime = useSelector(selectSystemMaintenanceShowUntilTime);

  if (!systemMaintenance || typeof systemMaintenance.call === 'function') return null;

  if (systemMaintenanceUntilTime) {
    const untilTime = new Date(systemMaintenanceUntilTime);
    const currentTime = new Date();

    if (currentTime > untilTime) {
      return null;
    }
  }

  const content = (
    <div css={styles} {...props}>
      <FontAwesomeIcon icon={faInfoCircle} className="icon" />
      <div>{systemMaintenance}</div>
    </div>
  );

  if (wrapWithSection) {
    return <Section {...sectionProps}>{content}</Section>;
  }

  if (Object.keys(wrapperProps).length > 0) {
    const WrapperElement = wrapperElement;
    return <WrapperElement {...wrapperProps}>{content}</WrapperElement>;
  }

  return content;
};
